// Pure function
// Never alter state or action directly

const scoreDefaultState = {
    subSections: {
        "11": {
            score: null,
            section: "core",
            title: "Need for Telehealth",
            weight: 0.5
        }, 
        "12": {
            score: null,
            section: "core",
            title: "Organizational Leadership Buy-In",
            weight: 0.5
        }, 
        "21": {
            score: null,
            section: "finance",
            title: undefined,
            weight: 1
        }, 
        "31": {
            score: null,
            section: "operations",
            title: "Telehealth Roles",
            weight: 0.125
        }, 
        "32": {
            score: null,
            section: "operations",
            title: "Scheduling and Workflow",
            weight: 0.25
        }, 
        "33": {
            score: null,
            section: "operations",
            title: "Operational Requirements",
            weight: 0.125
        }, 
        "34": {
            score: null,
            section: "operations",
            title: "Assessment Approach",
            weight: 0.125
        }, 
        "35": {
            score: null,
            section: "operations",
            title: "Technology",
            weight: 0.25
        }, 
        "36": {
            score: null,
            section: "operations",
            title: "Physical Space",
            weight: 0.125
        }, 
        "41": {
            score: null,
            section: "staff",
            title: "Education and Awareness",
            weight: 0.5
        }, 
        "42": {
            score: null,
            section: "staff",
            title: "Innovators and Champions",
            weight: 0.5
        }, 
        "51": {
            score: null,
            section: "patient",
            title: "Patient Engagement",
            weight: 0.5
        }, 
        "52": {
            score: null,
            section: "patient",
            title: "Health Literacy",
            weight: 0.5
        }
    },
    sections: {}
}

export default (state=scoreDefaultState, action) => {
    switch (action.type) {
        case 'SET_SUBSECTION_SCORE':
            return {
                ...state,
                subSections: {
                    ...state.subSections,
                    [action.subSecId]: {
                        ...state.subSections[action.subSecId],
                        score: action.score
                    }
                }
            }
        case 'SET_SECTION_SCORE':
            return {
                ...state,
                sections: {
                    ...state.sections,
                    [action.secId]: action.score
                }
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/score.js